import { lt } from '@mews/framework';
import { useDialogForm } from '@mews-commander/form';
import { Card } from '@optimus-web/core';
import type { PortfolioAmount } from '@mews-commander/data-access';
import type { ServiceCardProps } from '../types';
import { EditServicesProductForm } from '../forms/EditServicesProductForm';
import { CardHeader } from './CardHeader';
import { CardDetails } from './CardDetails';

export const ServiceCard = ({
    productId,
    service,
    enterpriseProductId,
    centralProductId,
    propertyId,
    bookablePeriod,
    options,
    promotions,
    adjustment,
    adjustedPrice,
    basePriceValue,
    charging,
    consumptionMoment,
    serviceType,
    ...detailsProps
}: ServiceCardProps) => {
    const [renderEditProductServicesForm, toggleEditProductServicesForm] = useDialogForm({
        title: lt('EditProductInService'),
        cancelLabel: lt('GoBack'),
        renderForm: (formProps) => (
            <EditServicesProductForm
                {...formProps}
                centralProductId={centralProductId as string}
                enterpriseProductId={enterpriseProductId}
                propertyId={propertyId}
                formRef={formProps.formRef}
                options={options}
                promotions={promotions}
                bookablePeriod={bookablePeriod}
                adjustment={adjustment}
                basePriceValue={basePriceValue as PortfolioAmount}
                charging={charging}
                consumptionMoment={consumptionMoment}
                serviceType={serviceType}
                productId={productId}
                serviceId={service.id}
            />
        ),
    });

    return (
        <>
            <Card key={service.id} padding="200">
                <CardHeader
                    service={service}
                    enterpriseProductId={enterpriseProductId}
                    productId={productId}
                    toggleEditProductServicesForm={toggleEditProductServicesForm}
                />
                <CardDetails
                    {...detailsProps}
                    options={options}
                    promotions={promotions}
                    bookablePeriod={bookablePeriod}
                    adjustment={adjustment}
                    adjustedPrice={adjustedPrice}
                    charging={charging}
                    consumptionMoment={consumptionMoment}
                />
            </Card>
            {centralProductId && basePriceValue && renderEditProductServicesForm()}
        </>
    );
};
